// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProfileEmptyState-ExploreButton___79a42b7b82dca737921{height:54px;width:226px}@media(max-width: 480px){.ProfileEmptyState-ExploreButton___79a42b7b82dca737921{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ExploreButton": "ProfileEmptyState-ExploreButton___79a42b7b82dca737921"
};
export default ___CSS_LOADER_EXPORT___;
